import { HERE_API_KEY } from '../config/constants';

/**
 * Searches for locations from a search query and a map view
 *
 * @param {string} query - search query
 * @param {Array<nuymber>} viewport - [lat1, lng1, lat2, lng2] bounding box of map view
 * @returns {Array<object>} search results
 */
export default async function findPlaces(query, viewport) {
  let center = [0, 0];
  if (viewport) {
    center = [(viewport[0] + viewport[2]) / 2, (viewport[1] + viewport[3]) / 2];
  }

  let params = new URLSearchParams({
    apiKey: HERE_API_KEY,
    at: center.join(','),
    limit: 5,
    q: encodeURIComponent(query)
  });
  if (viewport) {
    params.set('X-Map-Viewport', viewport.join(','));
  }

  let response = await fetch(`https://discover.search.hereapi.com/v1/discover?${params}`);
  let { items } = await response.json();

  return items.filter(item => item.position);
}
